import { ShipmentType } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";

export const PointBaseTypeModel = {
  SEA: "sea",
  LAND: "land",
  AIR: "air",
  TRAIN: "train",
  FACILITY: "facility",
  PARCEL: "parcel",
} as const;

export const RouteDataType = {
  SEA: "SEA",
  LAND: "LAND",
  AIR: "AIR",
  PARCEL: "PARCEL",
} as const;

export const TransportTypes = {
  TRUCK: "TRUCK",
  VESSEL: "VESSEL",
  RAIL: "RAIL",
  BARGE: "BARGE",
  FEEDER: "FEEDER",
  AIR: "AIR",
  PLANE: "PLANE",
  PARCEL: "PARCEL",
} as const;

export const MapClusterColorsMap: Record<ValueOf<typeof ShipmentType>, string> = {
  [ShipmentType.SEA]: "#08F",
  [ShipmentType.AIR]: "#F52C5C",
  [ShipmentType.RAIL]: "#FFAB1D",
  [ShipmentType.ROAD]: "#02BCB1",
  [ShipmentType.PARCEL]: "#E9B36B",
} as const;
